import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=ba1ab4e8&scoped=true&"
import script from "./policyDetail.vue?vue&type=script&lang=js&"
export * from "./policyDetail.vue?vue&type=script&lang=js&"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=ba1ab4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1ab4e8",
  null
  
)

export default component.exports